import WebpackLicensePlugin from './WebpackLicensePlugin'

export default WebpackLicensePlugin
